var h = Object.defineProperty;
var i = (e, t, r) => t in e ? h(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var o = (e, t, r) => (i(e, typeof t != "symbol" ? t + "" : t, r), r);
import { Component as n } from "react";
class a extends n {
  constructor() {
    super(...arguments);
    o(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(r, s) {
    console.error(r, s), this.props.setHasError(!0);
  }
  componentDidUpdate(r, s) {
    !r.hasError && this.props.hasError && !this.state.hasError ? this.setState({
      hasError: !0
    }) : r.hasError && !this.props.hasError && s.hasError && this.state.hasError && this.setState({
      hasError: !1
    });
  }
  render() {
    return this.state.hasError ? this.props.Error : this.props.children;
  }
}
const d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ErrorBoundary: a,
  default: a
}, Symbol.toStringTag, { value: "Module" }));
export {
  a as ErrorBoundary,
  d as index
};
